// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/recalculate_storage_usage.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/recalculate_storage_usage.proto.
 */
export const file_vision_billing_v1_recalculate_storage_usage: GenFile = /*@__PURE__*/
  fileDesc("CjF2aXNpb24vYmlsbGluZy92MS9yZWNhbGN1bGF0ZV9zdG9yYWdlX3VzYWdlLnByb3RvEhhwcm90b3MudmlzaW9uLmJpbGxpbmcudjEiewoeUmVjYWxjdWxhdGVTdG9yYWdlVXNhZ2VSZXF1ZXN0Ek8KBnBhcmFtcxgBIAEoCzI/LnByb3Rvcy52aXNpb24uYmlsbGluZy52MS5SZWNhbGN1bGF0ZVN0b3JhZ2VVc2FnZVJlcXVlc3QuUGFyYW1zGggKBlBhcmFtcyK2AQofUmVjYWxjdWxhdGVTdG9yYWdlVXNhZ2VSZXNwb25zZRJQCgZyZXN1bHQYASABKAsyQC5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuUmVjYWxjdWxhdGVTdG9yYWdlVXNhZ2VSZXNwb25zZS5SZXN1bHQaQQoGUmVzdWx0EhoKEnN0b3JhZ2VfdXNlZF9ieXRlcxgBIAEoAxIbChNzdG9yYWdlX2xpbWl0X2J5dGVzGAIgASgDYgZwcm90bzM");

/**
 * @generated from message protos.vision.billing.v1.RecalculateStorageUsageRequest
 */
export type RecalculateStorageUsageRequest = Message<"protos.vision.billing.v1.RecalculateStorageUsageRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.RecalculateStorageUsageRequest.Params params = 1;
   */
  params?: RecalculateStorageUsageRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.RecalculateStorageUsageRequest.
 * Use `create(RecalculateStorageUsageRequestSchema)` to create a new message.
 */
export const RecalculateStorageUsageRequestSchema: GenMessage<RecalculateStorageUsageRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_recalculate_storage_usage, 0);

/**
 * @generated from message protos.vision.billing.v1.RecalculateStorageUsageRequest.Params
 */
export type RecalculateStorageUsageRequest_Params = Message<"protos.vision.billing.v1.RecalculateStorageUsageRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.RecalculateStorageUsageRequest.Params.
 * Use `create(RecalculateStorageUsageRequest_ParamsSchema)` to create a new message.
 */
export const RecalculateStorageUsageRequest_ParamsSchema: GenMessage<RecalculateStorageUsageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_recalculate_storage_usage, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.RecalculateStorageUsageResponse
 */
export type RecalculateStorageUsageResponse = Message<"protos.vision.billing.v1.RecalculateStorageUsageResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.RecalculateStorageUsageResponse.Result result = 1;
   */
  result?: RecalculateStorageUsageResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.RecalculateStorageUsageResponse.
 * Use `create(RecalculateStorageUsageResponseSchema)` to create a new message.
 */
export const RecalculateStorageUsageResponseSchema: GenMessage<RecalculateStorageUsageResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_recalculate_storage_usage, 1);

/**
 * @generated from message protos.vision.billing.v1.RecalculateStorageUsageResponse.Result
 */
export type RecalculateStorageUsageResponse_Result = Message<"protos.vision.billing.v1.RecalculateStorageUsageResponse.Result"> & {
  /**
   * @generated from field: int64 storage_used_bytes = 1;
   */
  storageUsedBytes: bigint;

  /**
   * @generated from field: int64 storage_limit_bytes = 2;
   */
  storageLimitBytes: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.RecalculateStorageUsageResponse.Result.
 * Use `create(RecalculateStorageUsageResponse_ResultSchema)` to create a new message.
 */
export const RecalculateStorageUsageResponse_ResultSchema: GenMessage<RecalculateStorageUsageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_recalculate_storage_usage, 1, 0);

